import styled, { css } from 'styled-components';

export const ContentWrapper = styled.div`
  max-width: 1068px;
  margin: 0 auto;
  width: 100%;
`;

export const FooterWrapper = styled.div.attrs({
  className: 'd-flex w-100 justify-content-end',
})`
  button {
    border-radius: 0;
  }
`;

export const TypeSelectorCard = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  border: 1px solid #d3d3d3;
  border-radius: 12px;
  background: #fff;
  transition: all 0.2s ease;

  ${({ $interactive }) =>
    $interactive
      ? css`
          cursor: pointer;

          &:hover {
            background: #f9f9f9;
          }

          &:focus-visible {
            outline: none;
            border-color: #be1622;
          }
        `
      : css`
          cursor: default;
        `}
`;

export const TypeSelectorIcon = styled.div`
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;

  i {
    font-size: 28px;
    line-height: 1;
  }
`;

export const TypeSelectorInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const TypeSelectorLabel = styled.h3`
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  color: #333;
`;

export const TypeSelectorDescription = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0;
`;

export const TypeSelectorPlaceholder = styled.span`
  font-size: 16px;
  color: #999;
`;

export const TypeSelectorChangeHint = styled.span`
  font-size: 13px;
  color: #999;
  margin-left: auto;
  flex-shrink: 0;
`;
